import style from "./SettingsForm.module.css";

import { useFormWithValidation } from "@/features/forms/hooks/useFormWithValidation";
import { useEditSettings } from "../../hooks/useEditSettings";

import { FormProvider, useFormContext } from "react-hook-form";
import FormInput from "@/features/forms/components/FormInput";
import FormImage from "@/features/forms/components/FormImage";
import InputPhone from "@/features/forms/components/InputPhone";

import SettingsSection from "../settingsSection/SettingsSection";

import { successToast } from "@/ui/toast/Toast";
import Button from "@/ui/button/Button";
import Icon from "@/ui/icon/Icon";
import { useEffect, useMemo } from "react";

export default function SettingsForm({ user }) {
	const formMethods = useFormWithValidation({
		values: {
			username: user.username,
			email: user.email,
			first_name: user.firstName,
			last_name: user.lastName,
			picture: user.safe_picture_url,
		},
	});

	const {
		handleSubmit,
		formState: { isSubmitting, isDirty },
		watch,
	} = formMethods;

	const { save } = useEditSettings();

	const onSubmit = async (data) => {
		await save(data);
		successToast("Uspjesno spašene postavke");
	};

	const watchedValues = watch();

	useEffect(() => {
		if (watchedValues.picture && isDirty) {
			onSubmit(watchedValues);
		}
	}, [watchedValues.picture]);

	useEffect(() => {
		if (watchedValues.picture_clear && isDirty) {
			onSubmit(watchedValues);
		}
	}, [watchedValues.picture_clear]);

	return (
		<FormProvider {...formMethods}>
			<form onSubmit={handleSubmit(onSubmit)}>
				<SettingsSection
					title="O vama"
					description="Pregled Vaših informacija"
				>
					<div
						className={style.userCard}
						style={{
							"--background": `url(${watchedValues.picture})`,
						}}
					>
						<div className={style.imgHolder}>
							<FormImage
								initialPreviewImageURL={user.picture}
								name="picture"
							/>
						</div>
						<div className={style.info}>
							<span className={style.username}>
								@{watchedValues.username}
							</span>
							<span className={style.fullName}>
								{watchedValues.first_name}{" "}
								{watchedValues.last_name}
							</span>
						</div>
					</div>
				</SettingsSection>

				<SettingsSection
					title="Email adresa"
					description="Ova vrijednost se ne može mijenjati"
				>
					<FormInput notAllowed name="email" label="Email" />
				</SettingsSection>

				<SettingsSection
					title="Vaše lične informacije"
					description="Ovdje možete urediti Vaše lične infomracije"
				>
					<FormInput name="username" label="Korisničko ime" />
					<FormInput name="first_name" label="Ime" />
					<FormInput name="last_name" label="Prezime" />
				</SettingsSection>

				<div className={style.btnHolder}>
					<Button
						className={style.btn}
						type="accent"
						disabled={isSubmitting}
					>
						<Icon icon="fa-floppy-disk" />
						{isSubmitting ? <Icon icon="fa-ellipsis" /> : "Sačuvaj"}
					</Button>
				</div>
			</form>
		</FormProvider>
	);
}
